module.exports = __webpack_public_path__ + "static/media/HomeScreen_elImage5_1260450749.5e31d36d.png";